import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SystemCapabilityService } from 'src/app/services/system-capabilities/system-capability.service';
import { AppTabNavigationHeaderComponent } from '../../../components/navigation-header/app-navigation-header.component';
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';
import { QueryStringTabGroupDirective } from '../../../directives/query-string-tab-group.directive';
import { UserDirectoryComponent } from '../user-directory/user-directory.component';
import { BreadcrumbLabelDirective } from '../../../directives/breadcrumb-label.directive';
import { UserWhitelistComponent } from '../user-whitelist/user-whitelist.component';

@Component({
	selector: 'app-user-main-tab',
	templateUrl: './user-main-tab.component.html',
	styleUrls: ['./user-main-tab.component.scss'],
	imports: [
		AppTabNavigationHeaderComponent,
		MatTabGroup,
		QueryStringTabGroupDirective,
		MatTab,
		MatTabContent,
		UserDirectoryComponent,
		BreadcrumbLabelDirective,
		UserWhitelistComponent,
	],
})
export class UserMainTabComponent implements OnInit {
	userListBreadcrumbLabel = $localize`:@@userMainTab-breadcrumbLabelAllUsers:All Users`;
	whiteListBreadcrumbLabel = $localize`:@@userMainTab-whiteListBreadcrumbLabel:Whitelist`;
	userTitle = $localize`:@@user-mainUsersTitle:Users`;
	title = this.userTitle;
	canSeeWhitelistTab: boolean = false;
	canSeeWhitelistUsers: boolean = false;

	constructor(
		private readonly route: ActivatedRoute,
		private scService: SystemCapabilityService
	) {}

	ngOnInit(): void {
		this.canSeeWhitelistTab =
			this.scService.isCompanyAdmin || this.scService.isOracle;
		const params = this.route.snapshot.queryParams;
		const tabIndex = Number(params.tabIndex) ?? 0;
		this.changeTitle(tabIndex);
	}

	changeTitle(tabIndex: number) {
		switch (tabIndex) {
			case 0:
				this.title = this.userTitle;
				break;
			case 1:
				this.title = this.whiteListBreadcrumbLabel;
				break;
			default:
				this.title = this.userTitle;
				break;
		}
	}

	onWhitelistPageSelectionChanged(selection: WhitelistScreens): void {
		this.canSeeWhitelistUsers =
			selection === WhitelistScreens.whitelistUsers ? true : false;
	}
}

export const enum WhitelistScreens {
	whitelistUsers,
	whitelistDevices,
}
